const wrapper = "_275w85x7wa";
const heading = "_275h7j89it";
const body = "_275bxb6vhl";
const link = "_275l1tck6tf";
const button = "_275b1owgbuk";

export { body, button, heading, link, wrapper };
import "./atom.empty-state.style.linaria.module.css";
//# sourceMappingURL=atom.empty-state.style.js.map
